module.exports = __webpack_public_path__ + "static/media/message-sent.ee336ecd.svg";